import { action } from '@ember/object';
import { bannerError } from 'client-portal/utils/error-handling';
import { service } from '@ember/service';
import Controller from '@ember/controller';
import classic from 'ember-classic-decorator';

@classic
export default class SiteLicenseAgreementController extends Controller {
  @service intl;
  @service mixpanel;
  @service router;
  @service store;

  @action
  async acceptEula() {
    try {
      let adapter = this.store.adapterFor('client-access');

      await adapter.acceptEula();

      this.send('refreshEnvironment');
      this.router.transitionTo('site.home');
      this.trackEulaAccepted();
    } catch (err) {
      bannerError(err, { title: this.intl.t('messages.error.licenseAgreementNotAccepted') });
    }
  }

  @action
  trackEulaAccepted() {
    this.mixpanel.track('client: EULA accepted', { origin: 'client portal' });
  }
}
